import { render } from "./CompetitionAthletes.vue?vue&type=template&id=e3907632&scoped=true"
import script from "./CompetitionAthletes.vue?vue&type=script&lang=js"
export * from "./CompetitionAthletes.vue?vue&type=script&lang=js"

import "./CompetitionAthletes.vue?vue&type=style&index=0&id=e3907632&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3907632"]])

export default __exports__